/**
 * @file mixin to handle upload files from users' content sources, e.g. video recorder, drawing canvas, ...
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import InterstitialUploader from 'vuecomponents/interstitial_uploader.vue'

@Component({ components: { InterstitialUploader } })
export default class ContentSourceUploaderMixin extends Vue {
  @Prop({ default: true }) upload!: boolean

  file: File | null = null
  uploading = false
  // customize this in the actual component
  maxFileUploadSize = 0

  close(): void {
    // Implement this in the use site
  }

  handleFile(newFile: File): void {
    this.file = newFile
    if (this.upload) {
      this.uploading = true
    } else {
      this.$emit('upload-file', this.file, this.maxFileUploadSize)
    }
  }

  handleCaption(caption: string): void {
    if (caption) {
      this.$emit('caption', caption)
    }
  }

  onUploadCancel(): void {
    this.close()
    this.uploading = false
  }

  onUploadDone(file: File, url: string): void {
    this.$emit('select', url)
  }

  beforeDestroy(): void {
    this.uploading = false
  }
}
